import axios from "axios";
import { offlineAdapter, attachApi } from "@/lib/offline/engine";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let token = localStorage.getItem("lf_token");
export const getToken = () => token;
export const setToken = (t) => {
  token = t;
  if (t) localStorage.setItem("lf_token", t);
  else localStorage.removeItem("lf_token");
};

export const api = axios.create({ baseURL: API, withCredentials: true });
api.defaults.adapter = offlineAdapter(axios.getAdapter(axios.defaults.adapter));
attachApi(api);

export const isPublicView = () => window.location.pathname.startsWith("/p/");

const deviceId = () => {
  let id = localStorage.getItem("lf_device");
  if (!id) { id = (crypto.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}-${Math.random().toString(36).slice(2)}`); localStorage.setItem("lf_device", id); }
  return id;
};

api.interceptors.request.use((c) => {
  c.headers["X-Requested-With"] = "LoreRight";
  if (c.url.startsWith("/auth")) c.headers["X-Device-Id"] = deviceId();
  if (isPublicView() && !c.url.startsWith("/auth")) c.withCredentials = false;
  else if (token) c.headers.Authorization = `Bearer ${token}`;
  return c;
});

let refreshing = null;
const NO_RETRY = ["/auth/login", "/auth/register", "/auth/refresh", "/auth/logout", "/auth/forgot-password", "/auth/reset-password", "/email/unsubscribe", "/auth/change-password/deny"];

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const orig = err.config;
    if (err.response?.status === 401 && orig && !orig._retry && !isPublicView() && !NO_RETRY.some((u) => orig.url.includes(u))) {
      orig._retry = true;
      if (!refreshing) {
        refreshing = axios.post(`${API}/auth/refresh`, {}, { withCredentials: true }).finally(() => {
          setTimeout(() => (refreshing = null), 0);
        });
      }
      try {
        const { data } = await refreshing;
        setToken(data.access_token);
        return api(orig);
      } catch (e) {
        const st = e?.response?.status;
        if (st === 401 || st === 403) {
          setToken(null);
          window.dispatchEvent(new Event("lf-logout"));
        } else {
          return Promise.reject(e);
        }
      }
    }
    return Promise.reject(err);
  }
);

export function errMsg(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => (d && typeof d.msg === "string" ? d.msg : JSON.stringify(d))).join(" ");
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
